import React from 'react';

import type { TaskImportRunPhase } from '../../services/api/generated/taskImportRunsService';

type Props = { phase: TaskImportRunPhase };

export const RunStatusBadge: React.FC<Props> = ({ phase }) => {
  const base =
    'inline-flex items-center gap-2 px-2.5 py-1 rounded-md text-xs font-medium';
  return (
    <span
      className={`${base} bg-blue-100 text-blue-700`}
      aria-label={`Phase ${phase}`}
    >
      <span className="uppercase tracking-wide">{phase}</span>
    </span>
  );
};
